/* eslint-disable no-shadow */
// FIXME: TOO COMPLEX, USE `USE-FIELD-ARRAY`
import React, {ReactElement, useState, useEffect} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import {
  makeStyles,
  FormControl,
  FormHelperText,
  MenuItem,
  Grid,
  Select,
  Divider,
  Tooltip,
  IconButton,
  ListItemText,
  Radio,
  Switch,
  DialogActions,
  DialogTitle
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import {
  addPatientGurantorValidationWithHookForm
  // addPatientRowValidationWithHookForm
} from '@shared/modules/Patients/Patients';
import {
  createPatient,
  getGuarantor,
  updatePatient
} from '@shared/services/PatientsServices';
import {useForm, Controller} from 'react-hook-form';
import {Trans, useTranslation} from 'react-i18next';
import {useSnackbar} from 'notistack';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

// styles
import './AddPatientStyles.scss';
import {SnackBarConfig} from '../../../../../utils/SnackBarConfig';
// components and services
// import Close from '../../../../../components/system/MyIcons/Close';
import ButtonLoader from '../../../../../components/system/ButtonLoader/ButtonLoader';
import {
  APP_PRIMARY_COLOR,
  DEFAULT_RED_COLOR,
  // APP,
  // BORDER_COLOR,
  STATE_OBJECT_BORDER,
  STATE_OBJECT_OPACITY
} from '../../../../../style/variable';
import StyledOutlinedInput from '@components/system/FormInput/StyledOutlinedInput';
// import SelectOutlinedInput from '@components/system/FormInput/SelectOutlinedInput';
import PhoneInputField from '@components/system/PhoneInputField/PhoneInputField';
import {referenceDataService} from '@shared/services/ReferenceData.service';
import CustomSelectField from '../../../../../components/system/CustomSelectField/CustomSelectField';
// zip code validation
import validateZipCode from '@shared/utils/zipCode';
import {connect, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import VerifyInsuranceModal from '../Patientdetails/EligibilityVerification/VerifyInsuranceModal';
import {textFieldStyles} from '../../Invoices/TableDataAndStyles';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import HelperUtils from '@shared/utils/HelperUtils';
import DateTimePickerWrapper from '@components/system/CustomDateTimePicker/DateTimePickerWrapper';
import {
  PATIENT_FIELDS,
  PATIENT_GENDER_LIST,
  AppPermissions
} from '@shared/constants/Mapping';
import ConfirmationDialog from '@components/system/ConfirmationDialog/ConfirmationDialog';
import {State} from '@shared/store/reducers/Index';
import NavRoutes from 'src/constants/route/NavRoutes';
import {BASE_ROUTE_ADMIN} from 'src/constants/route/BaseRoute';
import {CommunicationService} from 'src/service/CommunicationService';
import ScheduleAppointment from '../../Appointments/ScheduleAppointment/ScheduleAppointment';
import {Patient} from '@shared/services/service-mappers/AppointmentSchedulingMapper';

interface CountryData {
  name: string;
  dialCode: string;
  countryCode: string;
  format: string;
}

const dialogStyles = makeStyles(() => ({
  zipText: {
    whiteSpace: 'nowrap'
  },
  headerInfo: {
    flex: 1,
    marginLeft: '0.7rem'
  },
  input: {
    width: '100%',
    borderRadius: '4px'
  },
  size: {
    textAlign: 'center',
    marginBottom: '0.4rem',
    fontSize: '0.7rem',
    opacity: 0.5
  },
  scheduleAppointment: {
    position: 'fixed',
    top: 40,
    left: 0,
    right: 0,
    bottom: 0,
    // Below MUI Menu/Popover (1300) so top-bar menus and profile stay usable
    zIndex: 1200,
    backgroundColor: '#fff',
    overflow: 'auto'
  }
}));

const dateInputStyles = makeStyles(() => ({
  dateWidth: {
    width: 'auto'
  }
}));
const FilterClinicStyles = makeStyles(() => ({
  root: {
    width: '400px',
    '&:focus': {
      outline: 'none'
    }
  },
  ClinicFilterHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 16px'
  },
  ClinicMenu: {
    overflow: 'auto',
    '& li': {
      borderBottom: '1px solid #eeeeee'
    },
    '& li:last-child': {
      borderBottom: 'none'
    }
  },
  secondary: {
    '& .MuiListItemText-secondary': {
      fontSize: '0.9rem',
      marginTop: '5px',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  primary: {
    '& .MuiListItemText-primary': {
      fontSize: '1.2rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  clearall: {
    textTransform: 'capitalize',
    fontSize: '1rem'
  },
  close: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '10px 16px',
    paddingTop: '16px'
  }
}));

const StateErrorStyles = {
  border: '1px solid red',
  height: '2.3rem',
  opacity: 0.5,
  borderRadius: '4px'
};

const stateObjectStyles = {
  // border: '1px solid #c1c1c1',
  height: '2.3rem',
  borderRadius: '4px'
};

const stateObjectOpacity = {
  border: `1px solidAddPat ${STATE_OBJECT_BORDER}`,
  height: '2.3rem',
  opacity: STATE_OBJECT_OPACITY,
  borderRadius: '4px'
};
interface IProps {
  open: boolean;
  onClose(response: 'confirm' | 'cancel'): void;
  clinicGroupId: number | string;
  fromEdit: boolean;
  clinics: any[];
  patientsShared: boolean | number;
  guarantorId?: any;
  addPatientToGuarantor?: boolean;
  clinicId?: any;
  editPatientContext?: any;
}

const AddPatient = (props: IProps): ReactElement => {
  const {
    open,
    onClose,
    clinicGroupId,
    fromEdit,
    clinics,
    guarantorId,
    addPatientToGuarantor,
    clinicId,
    editPatientContext
  } = props;
  const {t} = useTranslation();
  const history = useHistory();
  const [selectedClinic, setSelectedClinic] = React.useState<number>(0);
  const [buttonsDisable, setButtonsDisable] = useState<boolean>(false);
  const [toggleCheck, setToggleCheck] = React.useState<number>(-1);
  const [guarantorCheck, setGuarantorCheck] = React.useState<number>(-2);
  const [clinicLabels, setClinicLabels] = useState<string>('');
  const [openDialog, setOPenDialog] = useState<boolean>(false);
  const ClinicClasses = FilterClinicStyles();
  const [statesList, setStatesList]: any = useState([]);
  const [patientsComponents, updatePatientsComponents] = useState<number[]>([
    0
  ]);
  const patientsShared = useSelector(
    (state: any) => state?.clinics?.patientShared
  );
  const groupId = useSelector((state: State) => state.auth.groupId);
  const selectedClinicIdFromStore: any = useSelector(
    (state: any) => state.clinics.selectedClinicId || []
  );
  const userPermissions = useSelector(
    (state: State) => state.auth.userPermissions || {}
  );

  const pharmacyClaimsEnabled = !!userPermissions?.[groupId]?.['group']?.[
    AppPermissions.MENU_PERMISSIONS.PHARMACY_CLAIMS_ENABLE
  ];

  const {enqueueSnackbar} = useSnackbar();
  const classes = dialogStyles();
  const dateInputClasses = dateInputStyles();
  const textFieldClasses = textFieldStyles();
  const [patientDetails, setPatientDetails]: any = useState([]);
  const [, setGuarantorDetails]: any = useState({});

  const [patients, setPatients]: any = useState([]);

  const [deleteIndex, setDeleteIndex] = useState<any>(null);

  const [dialogContent, setDialogContent] = useState({
    dialogTitle: '',
    dialogDescription: '',
    cancelButtonText: '',
    confirmButtonText: '',
    buttonStyle: {
      backgroundColor: APP_PRIMARY_COLOR
    }
  });

  const [unSaved, setUnSaved] = useState<boolean>(false);

  const [showVerifyInsuranceModal, setShowVerifyInsuranceModal] = useState(
    false
  );
  const [verifyInsuranceContext, setVerifyInsuranceContext] = useState<{
    clinicId: number | string;
    patientId: number | string;
  } | null>(null);
  const [
    showAddInsuranceAndBookAppointmentDialog,
    setShowAddInsuranceAndBookAppointmentDialog
  ] = useState(false);
  const [
    showScheduleAppointmentDialog,
    setShowScheduleAppointmentDialog
  ] = useState(false);
  const [
    scheduleAppointmentClinicId,
    setScheduleAppointmentClinicId
  ] = useState<number | null>(null);
  const [
    scheduleAppointmentPatient,
    setScheduleAppointmentPatient
  ] = useState<Patient | null>(null);

  const handleClose = (response?: string) => {
    if (typeof onClose === 'function') {
      if (response == 'confirm') {
        onClose('confirm');
        return;
      }
      onClose('cancel');
    }
  };

  const getReferenceStates = (): void => {
    referenceDataService({key: 'ref-states'})
      .then(res => {
        if (res && res?.data && res?.data?.rows) {
          setStatesList([...statesList, ...(res?.data?.rows ?? [])]);
        }
      })
      .catch(err => {
        enqueueSnackbar(
          (err && err.message) || t('ADD_CLINIC.REFERENCE_STATE_ERROR'),
          SnackBarConfig('e')
        );
        throw err;
      });
  };

  useEffect(() => {
    getReferenceStates();
    if (!patientsShared && clinics.length == 1) {
      setSelectedClinic(clinics[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientsShared]);

  const formKey = (name: string, index: number) => {
    return `${name}_${index}`;
  };

  const removeExistsPatientsFormValues = (values: any): any => {
    patients.forEach((eachPatient: any, index: any) => {
      delete values[formKey('patient_id', index)];

      delete values[formKey('patient_first_name', index)];

      delete values[formKey('patient_middle_name', index)];

      delete values[formKey('patient_last_name', index)];

      delete values[formKey('patient_account_number', index)];

      delete values[formKey('patient_phone', index)];

      delete values[formKey('patient_email', index)];

      delete values[formKey('patient_address_line_1', index)];

      delete values[formKey('patient_address_line_2', index)];

      delete values[formKey('patient_city', index)];

      delete values[formKey('patient_state', index)];

      delete values[formKey('patient_zip_code', index)];

      delete values[formKey('patient_gender', index)];

      delete values[formKey('patient_ssn', index)];
    });

    return values;
  };

  const {
    control,
    getValues,
    handleSubmit,
    errors,
    setValue,
    formState
  }: any = useForm({
    mode: 'all',
    defaultValues: {},
    resolver: async (values: any) => {
      values.state = '';
      if (values.state === t('FORM.PLACEHOLDERS.STATE')) {
        values.state = '';
      }
      let errors_: any = {};

      // DELETE ALREADY EXITS PATIENT DETAILS FROM FORM VALIDATION
      if (patients.length) {
        values = removeExistsPatientsFormValues(values);
      }
      errors_ = addPatientGurantorValidationWithHookForm(values, {
        pharmacyClaimsEnabled
      });
      if (!patientsShared && !selectedClinic) {
        errors_.clinic = 'VALIDATORS.CLINIC';
      }
      return {values, errors: errors_};
    }
  });

  const updateUnsavedFlag = (): void => {
    if (!unSaved) {
      setUnSaved(true);
    }
  };

  const checkIsFormDirty = (): void => {
    const values = getValues();

    let changeFlag = false;

    for (let index = 0; index < patientsComponents.length; index++) {
      if (
        values[formKey('patient_dob', index)] ||
        values[formKey('state', index)]
      ) {
        changeFlag = true;
      }
    }

    if (unSaved || changeFlag) {
      setDialogContent({
        ...dialogContent,
        dialogTitle: t('CONFIRMATION_DIALOG.UN_SAVED_CHANGES'),
        dialogDescription: t('CONFIRMATION_DIALOG.UN_SAVED_SUB_TITLE'),
        cancelButtonText: t('CONFIRMATION_DIALOG.CANCEL'),
        confirmButtonText: t('CONFIRMATION_DIALOG.YES'),
        buttonStyle: {
          backgroundColor: APP_PRIMARY_COLOR
        }
      });
      setOPenDialog(true);
    } else {
      handleClose('cancel');
      setUnSaved(false);
    }
  };

  // To empty the guarantor details when the toggle switch is turned off
  const emptyGuarantorData = () => {
    setValue('first_name', '');
    setValue('last_name', '');
    setValue('middle_name', '');
    setValue('account_number', '');
    setValue('phone_1', '');
    setValue('email', '');
    setValue('address_line_1', '');
    setValue('address_line_2', '');
    setValue('city', '');
    setValue('state', t('FORM.PLACEHOLDERS.STATE'));
    setValue('zip_code', '');
  };

  // To add the guarantor details when the toggle switch is turned on
  const addGuarantorData = (idx: any) => {
    const patients = [];
    patients.push({
      first_name: getValues(`patient_first_name_${idx}`),
      last_name: getValues(`patient_last_name_${idx}`),
      middle_name: getValues(`patient_middle_name_${idx}`),
      account_number: getValues(`patient_account_number_${idx}`),
      cell_phone: getValues(`patient_phone_${idx}`),
      email: getValues(`patient_email_${idx}`),
      address_line_1: getValues(`patient_address_line_1_${idx}`),
      address_line_2: getValues(`patient_address_line_2_${idx}`),
      city: getValues(`patient_city_${idx}`),
      state: getValues(`patient_state_${idx}`),
      zip_code: getValues(`patient_zip_code_${idx}`),
      check: getValues(`checkedB_${idx}`),
      dob: getValues(`patient_dob_${idx}`)
    });

    if (
      patients[0].first_name !== '' &&
      patients[0].last_name !== '' &&
      patients[0].dob !== null &&
      patients[0].cell_phone !== ''
    ) {
      setValue('first_name', patients[0].first_name);
      setValue('last_name', patients[0].last_name);
      setValue('middle_name', patients[0].middle_name);
      setValue('account_number', patients[0].account_number);
      setValue('phone_1', patients[0].cell_phone);
      setValue('email', patients[0].email);
      setValue('address_line_1', patients[0].address_line_1);
      setValue('address_line_2', patients[0].address_line_2);
      setValue('city', patients[0].city);
      setValue('state', patients[0].state);
      setValue('zip_code', patients[0].zip_code);
      errors.first_name = '';
      errors.last_name = '';
      errors.phone_1 = '';
    } else {
      if (patients[0].first_name === '') {
        errors[formKey('patient_first_name', idx)] =
          'VALIDATORS.PATIENT_FIRST_NAME';
      }
      if (patients[0].last_name === '') {
        errors[formKey('patient_last_name', idx)] =
          'VALIDATORS.PATIENT_LAST_NAME';
      }
      if (patients[0].dob === null) {
        errors[formKey('patient_dob', idx)] = 'VALIDATORS.PATIENT_DOB';
      }
      if (patients[0].cell_phone === '') {
        errors[formKey('patient_phone', idx)] = 'VALIDATORS.PHONE';
      }
      setToggleCheck(-1);
      enqueueSnackbar(
        t('VALIDATORS.REQUIRED_PATIENT_GUARANTOR_COMMON_FIELDS'),
        SnackBarConfig('w')
      );
    }
  };

  const getClinicLabel = (clinicIdVal: number): string => {
    let clinicLabel = '';
    let index = 0;
    if (clinics && clinics?.length) {
      while (index < clinics.length) {
        if (clinics[index].id === clinicIdVal) {
          clinicLabel = clinics[index].name;
          break;
        }
        index++;
      }
    }
    return clinicLabel;
  };

  const GuarantorDetails = async () => {
    if (guarantorId) {
      getGuarantor(clinicGroupId, guarantorId, clinicId)
        .then(async res => {
          if (res && res?.data) {
            const clinicLabel = getClinicLabel(res?.data?.guarantor?.clinic_id);
            setClinicLabels(clinicLabel);
            setSelectedClinic(res?.data?.guarantor?.clinic_id);
            setGuarantorDetails(res?.data?.guarantor);
            setPatientDetails(res?.data?.patient);
            const guarantor = res?.data?.guarantor;
            const patients = res?.data?.patient;
            if (addPatientToGuarantor) {
              if (guarantor && Object.keys(guarantor).length) {
                // For Guarantor Data Pre Populating
                setValue('first_name', guarantor?.first_name);
                setValue('last_name', guarantor?.last_name);
                setValue('middle_name', guarantor?.middle_name);
                setValue('account_number', guarantor?.emr_id);
                setValue('phone_1', guarantor?.phone ?? '');
                setValue('phone_2', guarantor?.phone_2 ?? '');
                setValue('phone_3', guarantor?.phone_3 ?? '');
                setValue('email', guarantor?.email);
                setValue('address_line_1', guarantor?.address_line_1);
                setValue('address_line_2', guarantor?.address_line_2);
                setValue('city', guarantor?.city);
                setValue('state', guarantor?.state);
                setValue('zip_code', guarantor?.zip_code);
              }

              if (patients && patients?.length) {
                let p = new Array(patients.length).fill(0);

                setPatients(patients);
                p = p.map((value: any, index: number) => index);

                updatePatientsComponents(p);

                for (let i = 0; i < patients.length; ++i) {
                  setValue(formKey('patient_id', i), patients[i].id);
                  setValue(
                    formKey('patient_first_name', i),
                    patients[i].first_name
                  );
                  setValue(
                    formKey('patient_middle_name', i),
                    patients[i].middle_name
                  );
                  setValue(
                    formKey('patient_last_name', i),
                    patients[i].last_name
                  );
                  setValue(
                    formKey('patient_account_number', i),
                    patients[i].emr_id
                  );
                  // setValue(formKey('patient_dob', i), patients[i].dob);
                  setValue(
                    formKey('patient_phone', i),
                    patients[i].cell_phone ?? ''
                  );
                  setValue(formKey('patient_email', i), patients[i].email);
                  setValue(
                    formKey('patient_address_line_1', i),
                    patients[i].address_line_1
                  );
                  setValue(
                    formKey('patient_address_line_2', i),
                    patients[i].address_line_2
                  );
                  setValue(formKey('patient_city', i), patients[i].city);
                  setValue(formKey('patient_state', i), patients[i].state);
                  setValue(
                    formKey('patient_zip_code', i),
                    patients[i].zip_code
                  );
                  setValue(
                    formKey('patient_gender', i),
                    patients[i].gender ?? ''
                  );
                  setValue(formKey('patient_ssn', i), patients[i].ssn ?? '');
                }
              }
            }
            // }, 1000);
          }
        })
        .catch(err => {
          enqueueSnackbar(
            (err && err.message) || t('PATIENTS.GET_PATIENT_DETAILS_ERROR'),
            SnackBarConfig('e')
          );
        });
    }
  };

  React.useEffect(() => {
    GuarantorDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromEdit, guarantorId, addPatientToGuarantor]);

  // HANDLE FORM SUBMIT METHOD
  const handleFormSubmit = (): void => {
    if (clinics.length !== 1) {
      if (!patientsShared && !selectedClinic) {
        enqueueSnackbar(t('VALIDATORS.CLINIC'), SnackBarConfig('e'));
        return;
      }
    }
    setButtonsDisable(true);
    const newPatients: any[] = [];
    const allPatients: any[] = [];

    for (let idx = 0; idx < patientsComponents.length; idx++) {
      let rawId = getValues(`patient_id_${idx}`);
      let hasId =
        rawId !== null && rawId !== undefined && String(rawId).length > 0;

      // In edit mode, ensure the existing patient row has an id
      if (fromEdit && !hasId && idx === 0 && editPatientContext?.patient_id) {
        rawId = editPatientContext.patient_id;
        hasId = true;
      }

      const basePatient: any = {
        id: hasId ? rawId : null,
        first_name: getValues(`patient_first_name_${idx}`),
        last_name: getValues('patient_last_name_' + idx),
        middle_name: getValues('patient_middle_name_' + idx),
        account_number: getValues(`patient_account_number_${idx}`),
        cell_phone: getValues(`patient_phone_${idx}`),
        email: getValues(`patient_email_${idx}`),
        address_line_1: getValues(`patient_address_line_1_${idx}`),
        address_line_2: getValues(`patient_address_line_2_${idx}`),
        city: getValues(`patient_city_${idx}`),
        state:
          getValues(`patient_state_${idx}`) === t('FORM.PLACEHOLDERS.STATE')
            ? ''
            : getValues(`patient_state_${idx}`),
        zip_code: getValues(`patient_zip_code_${idx}`),
        dob: HelperUtils.formatDisplayDate(getValues(`patient_dob_${idx}`)),
        gender: PATIENT_GENDER_LIST.find(
          item => item.label === getValues(`patient_gender_${idx}`)
        )?.value,
        ssn: getValues(`patient_ssn_${idx}`)
      };

      allPatients.push(basePatient);

      // For create mode we only send newly added patients (no id)
      if (!hasId) {
        newPatients.push({
          ...basePatient,
          id: null
        });
      }
    }

    const payload = {
      clinic_id:
        clinics.length === 1
          ? clinics[0].id
          : selectedClinic
          ? selectedClinic
          : '',
      guarantor: {
        id: guarantorId,
        first_name: getValues('first_name'),
        last_name: getValues('last_name'),
        middle_name: getValues('middle_name'),
        account_number: getValues('account_number'),
        phone_1: getValues('phone_1'),
        phone_2: getValues('phone_2'),
        phone_3: getValues('phone_3'),
        email: getValues('email'),
        address_line_1: getValues('address_line_1'),
        address_line_2: getValues('address_line_2'),
        city: getValues('city'),
        state: getValues('state'),
        zip_code: getValues('zip_code')
      },
      patients: fromEdit ? allPatients : newPatients
    };
    const apiCall = fromEdit
      ? updatePatient(clinicGroupId, payload)
      : createPatient(clinicGroupId, payload);

    apiCall
      .then((res: any) => {
        enqueueSnackbar(
          res?.message ||
            (fromEdit
              ? t('ADD_PATIENT.PATIENT_UPDATE_SUCCESS')
              : t('ADD_PATIENT.PATIENT_ADD_SUCCESS')),
          SnackBarConfig('s')
        );

        // Open insurance confirmation for the first created patient, if available
        const createdPatient = res?.data?.patients?.[0];
        if (createdPatient?.id && res?.data?.patients?.length === 1) {
          const clinicForInsurance =
            clinics.length === 1
              ? clinics[0].id
              : selectedClinic
              ? selectedClinic
              : '';

          setVerifyInsuranceContext({
            clinicId: clinicForInsurance,
            patientId: createdPatient.id
          });
          const clinicIdForSchedule =
            createdPatient.clinic_id ||
            clinicForInsurance ||
            clinicId ||
            (Array.isArray(selectedClinicIdFromStore)
              ? selectedClinicIdFromStore?.[0]
              : selectedClinicIdFromStore);
          setScheduleAppointmentClinicId(
            clinicIdForSchedule ? Number(clinicIdForSchedule) : null
          );
          setScheduleAppointmentPatient({
            id: createdPatient.id,
            first_name: getValues(formKey('patient_first_name', 0)),
            last_name: getValues(formKey('patient_last_name', 0)),
            middle_name: getValues(formKey('patient_middle_name', 0))
          });
          setShowAddInsuranceAndBookAppointmentDialog(true);
        } else {
          // If we don't have a patient id, just close as before
          handleClose('confirm');
        }

        setToggleCheck(-1);
      })
      .catch(err => {
        if (typeof err?.data?.row !== 'undefined') {
          errors[formKey('patient_account_number', err.data.row)] = err.message;
        }
        enqueueSnackbar(
          (err && err.message) ||
            (fromEdit
              ? t('ADD_PATIENT.PATIENT_UPDATE_ERROR')
              : t('ADD_PATIENT.PATIENT_ADD_ERROR')),
          SnackBarConfig('e')
        );
        throw err;
      })
      .finally(() => {
        setButtonsDisable(false);
      });
  };

  // To reflect the changes in the guarantor details when the toggle switch is on and changes are made in patient details
  const handlePatientChange = (index: any) => {
    if (index === toggleCheck && index === guarantorCheck) {
      {
        addGuarantorData(index);
      }
    }
  };
  const mapPatientDetailsToGuarantor = (event: any, index: any) => {
    for (let idx = 0; idx < patientsComponents.length; idx++) {
      if (idx === index && event.target.checked === false) {
        setToggleCheck(-1);
        {
          emptyGuarantorData();
          if (fromEdit) {
            getGuarantor(clinicGroupId, guarantorId, clinicId)
              .then(res => {
                setSelectedClinic(res?.data?.guarantor?.clinic_id);
                // For Guarantor Data Pre populating
                setValue('first_name', res?.data?.guarantor?.first_name);
                setValue('last_name', res?.data?.guarantor?.last_name);
                setValue('middle_name', res?.data?.guarantor?.middle_name);
                setValue('account_number', res?.data?.guarantor?.emr_id);
                setValue('phone_1', res?.data?.guarantor?.phone);
                setValue('phone_2', res?.data?.guarantor?.phone_2);
                setValue('phone_3', res?.data?.guarantor?.phone_3);
                setValue('email', res?.data?.guarantor?.email);
                setValue(
                  'address_line_1',
                  res?.data?.guarantor?.address_line_1
                );
                setValue(
                  'address_line_2',
                  res?.data?.guarantor?.address_line_2
                );
                setValue('city', res?.data?.guarantor?.city);
                setValue('state', res?.data?.guarantor?.state);
                setValue('zip_code', res?.data?.guarantor?.zip_code);
              })
              .catch((err: any) => {
                throw err;
              });
          }
        }
      } else if (idx === index && event.target.checked === true) {
        setToggleCheck(idx);
        setGuarantorCheck(idx);
        {
          addGuarantorData(idx);
        }
      }
    }
  };

  const handleOnChange = (
    event: any,
    country: CountryData | null,
    key: any
  ): any => {
    event.persist();
    event.target.setAttribute('autocomplete', 'off');
    setTimeout(() => {
      setValue(key, '' + event?.target?.value, {
        shouldValidate: true
      });
    }, 10);
  };

  const handleClinicSelect = (event: any, clinic: any) => {
    setClinicLabels(clinic.name);
    setSelectedClinic(clinic.id);
  };

  const clearClinicFilter = () => {
    setSelectedClinic(0);
    setClinicLabels('');
  };

  const showConfirmationStatementDialog = (idx: number | any): ReactElement => {
    return (
      <ConfirmationDialog
        open={openDialog}
        onClose={res => {
          if (res === 'confirm') {
            if (deleteIndex || typeof deleteIndex == 'number') {
              // fetching all the input fields
              const data = getValues();
              let fieldName = '';
              Object.values(PATIENT_FIELDS).map((field: any) => {
                fieldName = field + '_' + deleteIndex;
                const keys = Object.keys(data);
                keys.forEach((key: any) => {
                  if (key === fieldName) {
                    setValue(fieldName, '');
                  }
                });
              });
              const existPatientForms = [...patientsComponents];
              existPatientForms.splice(deleteIndex, 1);

              updatePatientsComponents(existPatientForms);
              setDeleteIndex(null);
              setOPenDialog(false);
              setUnSaved(false);
            } else {
              handleClose('cancel');
              setOPenDialog(false);
              setUnSaved(false);
            }
          } else if (res === 'cancel') {
            setOPenDialog(false);
          }
        }}
        title={
          <Trans
            i18nKey={dialogContent.dialogTitle}
            components={[<strong key={'X'} />]}
          />
        }
        description={
          <Trans
            i18nKey={dialogContent.dialogDescription}
            components={[<strong key={'X'} />]}
          />
        }
        confirmButtonText={dialogContent.confirmButtonText}
        cancelButtonText={dialogContent.cancelButtonText}
        className={dialogContent.buttonStyle}
      />
    );
  };

  const handlePopUpDialog = (idx: number): any => {
    const data = getValues();
    let formHasValues = false;
    Object.values(PATIENT_FIELDS).map((field: any) => {
      const fieldName = field + '_' + idx;
      if (data[fieldName] && data[fieldName]._isAMomentObject) {
        formHasValues = true;
      } else if (
        data[fieldName] &&
        data[fieldName]?.toLowerCase().trim() !== 'select state'
      ) {
        formHasValues = true;
      }
    });
    if (!formHasValues) {
      const existPatientForms = [...patientsComponents];
      existPatientForms.splice(idx, 1);
      updatePatientsComponents(existPatientForms);
      setDeleteIndex(null);
    } else {
      setDeleteIndex(idx);
      setOPenDialog(true);
    }
  };

  const renderToggleSwitch = (index: number): ReactElement => {
    return (
      <div key={index}>
        <Grid container spacing={1}>
          <Grid item xs={6} sm={12}>
            <div>
              {t('ADD_PATIENT.PLACEHOLDERS.GUARANTOR_PATIENT')}
              <span style={{marginLeft: '0.5rem'}}>
                {t('ADD_PATIENT.PLACEHOLDERS.NO')}
              </span>
              <Switch
                disabled={addPatientToGuarantor}
                checked={toggleCheck === index}
                onChange={(event: any) => {
                  mapPatientDetailsToGuarantor(event, index);
                }}
                color="primary"
                style={{marginBottom: '0.5rem'}}
                name={formKey('checkedB', index)}
                inputProps={{'aria-label': 'primary checkbox'}}
              />
              {t('ADD_PATIENT.PLACEHOLDERS.YES')}
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  const patientIdForm = (index: number): ReactElement => {
    return (
      <FormControl
        error={!!errors[formKey('patient_id', index)]}
        fullWidth={true}
        variant="outlined"
        onChange={() => handlePatientChange(index)}>
        <Controller
          id={formKey('patient_id', index)}
          as={StyledOutlinedInput}
          margin={'dense'}
          control={control}
          name={formKey('patient_id', index)}
          type={'text'}
          value={'text'}
          autoComplete="on"
          placeholder={t('ADD_PATIENT.PLACEHOLDERS.PATIENT_FIRST_NAME')}
          error={!!errors[formKey('patient_id', index)]}
          defaultValue={''}
        />
        {errors[formKey('patient_id', index)] && (
          <FormHelperText>
            {t(errors[formKey('patient_id', index)])}
          </FormHelperText>
        )}
      </FormControl>
    );
  };

  const renderPatientForm = (index: number): ReactElement => {
    return (
      <div key={'patient' + index}>
        <Grid container spacing={1}>
          <Grid item xs={6} sm={4}>
            <div>{t('ADD_PATIENT.PATIENT_FIRST_NAME')}*</div>
            <FormControl
              error={!!errors[formKey('patient_first_name', index)]}
              fullWidth={true}
              variant="outlined"
              onChange={() => {
                updateUnsavedFlag();
                handlePatientChange(index);
              }}>
              <Controller
                id={formKey('patient_first_name', index)}
                as={StyledOutlinedInput}
                margin={'dense'}
                control={control}
                name={formKey('patient_first_name', index)}
                type={'text'}
                value={'text'}
                autoComplete="on"
                placeholder={t('ADD_PATIENT.PLACEHOLDERS.PATIENT_FIRST_NAME')}
                error={!!errors[formKey('patient_first_name', index)]}
                defaultValue={editPatientContext?.first_name ?? ''}
                disabled={!fromEdit && index < patientDetails.length}
              />
              {errors[formKey('patient_first_name', index)] && (
                <FormHelperText>
                  {t(errors[formKey('patient_first_name', index)])}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4}>
            <div>{t('ADD_PATIENT.PATIENT_MIDDLE_NAME')}</div>
            <FormControl
              error={!!errors[formKey('patient_middle_name', index)]}
              fullWidth={true}
              variant="outlined"
              onChange={() => {
                updateUnsavedFlag();
                handlePatientChange(index);
              }}>
              <Controller
                id={formKey('patient_middle_name', index)}
                as={StyledOutlinedInput}
                margin={'dense'}
                control={control}
                name={formKey('patient_middle_name', index)}
                type={'text'}
                value={'text'}
                autoComplete="on"
                placeholder={t('ADD_PATIENT.PLACEHOLDERS.PATIENT_MIDDLE_NAME')}
                error={!!errors[formKey('patient_middle_name', index)]}
                defaultValue={editPatientContext?.middle_name ?? ''}
                disabled={!fromEdit && index < patientDetails.length}
              />
              {errors[formKey('patient_middle_name', index)] && (
                <FormHelperText>
                  {t(errors[formKey('patient_middle_name', index)])}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4}>
            <div>{t('ADD_PATIENT.PATIENT_LAST_NAME')}*</div>
            <FormControl
              error={!!errors[formKey('patient_last_name', index)]}
              fullWidth={true}
              variant="outlined"
              onChange={() => {
                updateUnsavedFlag();
                handlePatientChange(index);
              }}>
              <Controller
                id={formKey('patient_last_name', index)}
                as={StyledOutlinedInput}
                margin={'dense'}
                control={control}
                name={formKey('patient_last_name', index)}
                type={'text'}
                value={'text'}
                autoComplete="on"
                placeholder={t('ADD_PATIENT.PLACEHOLDERS.PATIENT_LAST_NAME')}
                error={!!errors[formKey('patient_last_name', index)]}
                defaultValue={editPatientContext?.last_name ?? ''}
                disabled={!fromEdit && index < patientDetails.length}
              />
              {errors[formKey('patient_last_name', index)] && (
                <FormHelperText>
                  {t(errors[formKey('patient_last_name', index)])}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4}>
            <div>{t('ADD_PATIENT.PATIENT_ACCOUNT_NUMBER')}</div>
            <FormControl
              error={!!errors[formKey('patient_account_number', index)]}
              fullWidth={true}
              variant="outlined"
              onChange={() => {
                updateUnsavedFlag();
                handlePatientChange(index);
              }}>
              <Controller
                id={formKey('patient_account_number', index)}
                as={StyledOutlinedInput}
                margin={'dense'}
                control={control}
                name={formKey('patient_account_number', index)}
                type={'text'}
                value={'text'}
                autoComplete="on"
                placeholder={t(
                  'ADD_PATIENT.PLACEHOLDERS.PATIENT_ACCOUNT_NUMBER'
                )}
                error={!!errors[formKey('patient_account_number', index)]}
                defaultValue={editPatientContext?.account_number ?? ''}
                disabled={!fromEdit && index < patientDetails.length}
              />
              {errors[formKey('patient_account_number', index)] && (
                <FormHelperText>
                  {t(errors[formKey('patient_account_number', index)])}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          {index >= patientDetails.length || fromEdit ? (
            <Grid item xs={6} sm={4}>
              <div>
                <div style={{marginBottom: '8px'}}>{t('ADD_PATIENT.DOB')}*</div>
                <FormControl
                  error={!!errors[formKey('patient_dob', index)]}
                  fullWidth={true}
                  variant="outlined"
                  // onChange={() => {
                  //   updateUnsavedFlag();
                  // }}
                >
                  <Controller
                    id={formKey('patient_dob', index)}
                    as={
                      <DateTimePickerWrapper
                        value={null}
                        disableFuture={true}
                        inputProps={{
                          name: formKey('patient_dob', index),
                          id: formKey('patient_dob', index),
                          required: true
                        }}
                        placeholder={t('DUE_INVOICES.PLACEHOLDERS.FROM_DATE')}
                        onChange={(date: unknown): void => {
                          setValue(
                            formKey('patient_dob', index),
                            date ?? null,
                            {
                              shouldValidate: true
                            }
                          );
                          updateUnsavedFlag();
                          handlePatientChange(index);
                        }}
                        className={[
                          textFieldClasses.adornedEnd,
                          dateInputClasses.dateWidth,
                          textFieldClasses.dateInputStyle
                        ].join(' ')}
                      />
                    }
                    margin={'dense'}
                    control={control}
                    name={formKey('patient_dob', index)}
                    type={'string'}
                    value={'text'}
                    autoComplete="on"
                    placeholder={t('ADD_PATIENT.PLACEHOLDERS.DOB')}
                    error={!!errors[formKey('patient_dob', index)]}
                    defaultValue={editPatientContext?.dob ?? ''}
                    disabled={!fromEdit && index < patientDetails.length}
                  />
                  {errors[formKey('patient_dob', index)] && (
                    <FormHelperText>
                      {t(errors[formKey('patient_dob', index)])}
                    </FormHelperText>
                  )}
                </FormControl>
              </div>
            </Grid>
          ) : (
            ''
          )}
          <Grid item xs={6} sm={4}>
            <div style={{marginBottom: '8px'}}>{t('ADD_PATIENT.GENDER')}</div>
            <FormControl
              error={!!errors[formKey('patient_gender', index)]}
              fullWidth={true}
              variant="outlined"
              style={{border: 'none'}}
              onClick={() => {
                handlePatientChange(index);
              }}>
              <Controller
                id={formKey('patient_gender', index)}
                margin={'dense'}
                render={({onChange, onBlur, value}): React.ReactElement => (
                  <Select
                    id="designation-selector"
                    value={value}
                    data-test-id="pcl-practices-patientState"
                    onChange={(data: any) => {
                      onChange(data);
                      updateUnsavedFlag();
                    }}
                    onBlur={onBlur}
                    fullWidth={true}
                    variant="outlined"
                    margin="dense"
                    IconComponent={KeyboardArrowDownIcon}
                    placeholder={t('FORM.PLACEHOLDERS.GENDER')}
                    input={<CustomSelectField />}
                    disabled={!fromEdit && index < patientDetails.length}
                    className={[classes.input].join(' ')}
                    style={
                      errors[formKey('patient_gender', index)]
                        ? {...StateErrorStyles}
                        : value === t('FORM.PLACEHOLDERS.GENDER') ||
                          (!fromEdit && index < patientDetails.length)
                        ? {...stateObjectOpacity}
                        : {...stateObjectStyles}
                    }>
                    {PATIENT_GENDER_LIST.map(
                      (
                        item: {
                          value: string;
                          label: string;
                        },
                        idx: any
                      ) => (
                        <MenuItem
                          value={item.label}
                          key={`patient-${index}-gender-${item.value}`}>
                          {item.label}
                        </MenuItem>
                      )
                    )}
                  </Select>
                )}
                control={control}
                name={formKey('patient_gender', index)}
                error={!!errors[formKey('patient_gender', index)]}
                defaultValue={
                  PATIENT_GENDER_LIST.find(
                    item => item.value === editPatientContext?.patient_gender
                  )?.label ?? ''
                }
              />
              {errors[formKey('patient_gender', index)] && (
                <FormHelperText>
                  {t(errors[formKey('patient_gender', index)])}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
        </Grid>
        <Grid container key={`patient-${index}-contact`} spacing={1}>
          <Grid item xs={6} sm={4}>
            <div>{t('ADD_PATIENT.PHONE_NUMBER')}*</div>
            <FormControl
              error={!!errors[formKey('patient_phone', index)]}
              fullWidth={true}
              variant="outlined"
              onChange={() => {
                updateUnsavedFlag();
              }}
              onMouseMove={() => handlePatientChange(index)}>
              <Controller
                id={formKey('patient_phone', index)}
                as={
                  <PhoneInputField
                    value={''}
                    inputProps={{
                      name: formKey('patient_phone', index),
                      id: formKey('patient_phone', index),
                      required: false
                    }}
                    onChange={(value: any, country: CountryData) =>
                      handleOnChange(
                        value,
                        country,
                        formKey('patient_phone', index)
                      )
                    }
                  />
                }
                margin={'dense'}
                control={control}
                name={formKey('patient_phone', index)}
                type={'number'}
                value={'text'}
                autoComplete="on"
                placeholder={t('ADD_PATIENT.PLACEHOLDERS.PHONE_NUMBER')}
                error={!!errors[formKey('patient_phone', index)]}
                defaultValue={editPatientContext?.patient_phone ?? ''}
                disabled={!fromEdit && index < patientDetails.length}
              />
              {errors[formKey('patient_phone', index)] && (
                <FormHelperText>
                  {t(errors[formKey('patient_phone', index)])}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4}>
            <div>{t('ADD_PATIENT.PATIENT_EMAIL')}</div>
            <FormControl
              error={!!errors[formKey('patient_email', index)]}
              fullWidth={true}
              variant="outlined"
              onChange={() => {
                updateUnsavedFlag();
                handlePatientChange(index);
              }}>
              <Controller
                id={formKey('patient_email', index)}
                as={StyledOutlinedInput}
                margin={'dense'}
                control={control}
                name={formKey('patient_email', index)}
                type={'text'}
                value={formKey('patient_email', index)}
                autoComplete="on"
                placeholder={t('ADD_PATIENT.PLACEHOLDERS.PATIENT_EMAIL')}
                error={!!errors[formKey('patient_email', index)]}
                defaultValue={editPatientContext?.patient_email ?? ''}
                disabled={!fromEdit && index < patientDetails.length}
              />
              {errors[formKey('patient_email', index)] && (
                <FormHelperText>
                  {t(errors[formKey('patient_email', index)])}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4}>
            <div>
              {t('ADD_PATIENT.ADDRESS_LINE_1')}
              {pharmacyClaimsEnabled ? '*' : ''}
            </div>
            <FormControl
              error={!!errors[formKey('patient_address_line_1', index)]}
              fullWidth={true}
              variant="outlined"
              onChange={() => {
                updateUnsavedFlag();
                handlePatientChange(index);
              }}>
              <Controller
                id={formKey('patient_address_line_1', index)}
                as={StyledOutlinedInput}
                margin={'dense'}
                control={control}
                name={formKey('patient_address_line_1', index)}
                type={'text'}
                value={'text'}
                autoComplete="on"
                placeholder={t('FORM.PLACEHOLDERS.ADDRESS_1')}
                error={!!errors[formKey('patient_address_line_1', index)]}
                defaultValue={editPatientContext?.patient_address_line_1 ?? ''}
                disabled={!fromEdit && index < patientDetails.length}
              />
              {errors[formKey('patient_address_line_1', index)] && (
                <FormHelperText>
                  {t(errors[formKey('patient_address_line_1', index)])}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
        </Grid>
        <Grid container key={`patient-${index}-address-extra`} spacing={1}>
          <Grid item xs={6} sm={4}>
            <div>{t('ADD_PATIENT.ADDRESS_LINE_2')}</div>
            <FormControl
              error={!!errors[formKey('patient_address_line_2', index)]}
              fullWidth={true}
              variant="outlined"
              onChange={() => {
                updateUnsavedFlag();
                handlePatientChange(index);
              }}>
              <Controller
                id={formKey('patient_address_line_2', index)}
                as={StyledOutlinedInput}
                margin={'dense'}
                control={control}
                name={formKey('patient_address_line_2', index)}
                type={'text'}
                value={'text'}
                autoComplete="on"
                placeholder={t('FORM.PLACEHOLDERS.ADDRESS_2')}
                defaultValue={editPatientContext?.patient_address_line_2 ?? ''}
                disabled={!fromEdit && index < patientDetails.length}
              />
              {errors[formKey('patient_address_line_2', index)] && (
                <FormHelperText>
                  {t(errors[formKey('patient_address_line_2', index)])}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4}>
            <div>
              {t('ADD_PATIENT.CITY')}
              {pharmacyClaimsEnabled ? '*' : ''}
            </div>
            <FormControl
              error={!!errors[formKey('patient_city', index)]}
              fullWidth={true}
              variant="outlined"
              onChange={() => {
                updateUnsavedFlag();
                handlePatientChange(index);
              }}>
              <Controller
                id={formKey('patient_city', index)}
                as={StyledOutlinedInput}
                margin={'dense'}
                control={control}
                name={formKey('patient_city', index)}
                type={'text'}
                value={'text'}
                autoComplete="on"
                placeholder={t('FORM.PLACEHOLDERS.CITY')}
                error={!!errors[formKey('patient_city', index)]}
                defaultValue={editPatientContext?.patient_city ?? ''}
                disabled={!fromEdit && index < patientDetails.length}
              />
              {errors[formKey('patient_city', index)] && (
                <FormHelperText>
                  {t(errors[formKey('patient_city', index)])}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4}>
            <div style={{marginBottom: '8px'}}>
              {t('ADD_PATIENT.STATE')}
              {pharmacyClaimsEnabled ? '*' : ''}
            </div>
            <FormControl
              error={!!errors[formKey('patient_state', index)]}
              fullWidth={true}
              variant="outlined"
              style={{border: 'none'}}
              onClick={() => {
                handlePatientChange(index);
              }}>
              <Controller
                id={formKey('patient_state', index)}
                margin={'dense'}
                render={({onChange, onBlur, value}): React.ReactElement => (
                  <Select
                    id="designation-selector"
                    value={value}
                    data-test-id="pcl-practices-patientState"
                    onChange={(data: any) => {
                      onChange(data);
                      updateUnsavedFlag();
                    }}
                    onBlur={onBlur}
                    fullWidth={true}
                    variant="outlined"
                    margin="dense"
                    IconComponent={KeyboardArrowDownIcon}
                    placeholder={t('FORM.PLACEHOLDERS.STATE')}
                    input={<CustomSelectField />}
                    disabled={!fromEdit && index < patientDetails.length}
                    className={[classes.input].join(' ')}
                    style={
                      errors[formKey('patient_state', index)]
                        ? {...StateErrorStyles}
                        : value === t('FORM.PLACEHOLDERS.STATE') ||
                          (!fromEdit && index < patientDetails.length)
                        ? {...stateObjectOpacity}
                        : {...stateObjectStyles}
                    }>
                    {statesList.map(
                      (
                        item: {
                          name: string | number | string[] | undefined;
                          label: React.ReactNode;
                        },
                        idx: any
                      ) => (
                        <MenuItem
                          value={item.name}
                          key={`patient-${index}-state-${String(
                            item.name
                          )}-${idx}`}>
                          {item.name}
                        </MenuItem>
                      )
                    )}
                  </Select>
                )}
                control={control}
                name={formKey('patient_state', index)}
                error={!!errors[formKey('patient_state', index)]}
                defaultValue={editPatientContext?.patient_state ?? ''}
              />
              {errors[formKey('patient_state', index)] && (
                <FormHelperText>
                  {t(errors[formKey('patient_state', index)])}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4}>
            <div>
              {t('ADD_PATIENT.ZIP_CODE')}
              {pharmacyClaimsEnabled ? '*' : ''}
            </div>
            <FormControl
              error={!!errors[formKey('patient_zip_code', index)]}
              fullWidth={true}
              variant="outlined"
              onChange={() => {
                updateUnsavedFlag();
                handlePatientChange(index);
              }}>
              <Controller
                id={formKey('patient_zip_code', index)}
                as={StyledOutlinedInput}
                margin={'dense'}
                control={control}
                name={formKey('patient_zip_code', index)}
                type={'number'}
                value={'text'}
                autoComplete="on"
                placeholder={t('FORM.PLACEHOLDERS.ZIP')}
                onInput={(e: any) => {
                  e.target.value = validateZipCode(e);
                }}
                error={!!errors[formKey('patient_zip_code', index)]}
                defaultValue={editPatientContext?.patient_zip_code ?? ''}
                disabled={!fromEdit && index < patientDetails.length}
              />
              {errors[formKey('patient_zip_code', index)] && (
                <FormHelperText className={classes.zipText}>
                  {t(errors[formKey('patient_zip_code', index)])}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4}>
            <div>{t('ADD_PATIENT.SSN')}</div>
            <FormControl
              error={!!errors[formKey('patient_ssn', index)]}
              fullWidth={true}
              variant="outlined"
              onChange={() => {
                updateUnsavedFlag();
                handlePatientChange(index);
              }}>
              <Controller
                id={formKey('patient_ssn', index)}
                as={StyledOutlinedInput}
                margin={'dense'}
                control={control}
                name={formKey('patient_ssn', index)}
                type={'text'}
                value={'text'}
                autoComplete="on"
                placeholder={t('FORM.PLACEHOLDERS.SSN')}
                error={!!errors[formKey('patient_ssn', index)]}
                defaultValue={editPatientContext?.patient_ssn ?? ''}
                disabled={!fromEdit && index < patientDetails.length}
              />
              {errors[formKey('patient_ssn', index)] && (
                <FormHelperText>
                  {t(errors[formKey('patient_ssn', index)])}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          {(!addPatientToGuarantor || fromEdit) && (
            <Grid item xs={6} sm={12}>
              {renderToggleSwitch(index)}
            </Grid>
          )}
        </Grid>
      </div>
    );
  };

  const handleAddPatient = () => {
    // setPatientData(false);
    // setAddPatient(addPatient + 1)
    updatePatientsComponents([
      ...patientsComponents,
      ...[patientsComponents.length + 1]
    ]);
  };

  const checkFormState = (): void => {
    const {isValid} = formState;
    if (!isValid) {
      enqueueSnackbar(
        t('VALIDATORS.REQUIRED_FORM_FIELD_MESSAGE'),
        SnackBarConfig('w')
      );
    }
  };

  return (
    <div>
      <Dialog
        fullScreen={false}
        open={open && !showScheduleAppointmentDialog}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        maxWidth={'md'}>
        <DialogTitle disableTypography>
          {fromEdit
            ? t('ADD_PATIENT.EDIT_PATIENT')
            : t('ADD_PATIENT.ADD_PATIENT')}
        </DialogTitle>
        <DialogContent dividers>
          <div className="divStyle">
            <div className="header">
              <div className={classes.headerInfo}>
                {fromEdit
                  ? t('ADD_PATIENT.EDIT_PATIENT_INFO')
                  : t('ADD_PATIENT.CREATE_PATIENT_INFO_SUB_TITLE')}
              </div>
            </div>
            {!patientsShared && !fromEdit ? (
              <div>
                <div className="label">{t('ADD_PATIENT.GUARANTOR.CLINIC')}</div>
                <FormControl
                  error={!!errors.clinic}
                  fullWidth={true}
                  variant="outlined"
                  className="select_clinic"
                  onChange={() => {
                    updateUnsavedFlag();
                  }}>
                  <Controller
                    id="clinic"
                    control={control}
                    name={'clinic'}
                    defaultValue={''}
                    render={({onBlur}): React.ReactElement => (
                      <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        onBlur={onBlur}
                        data-test-id="pcl-patients-practiceDropdown"
                        margin={'dense'}
                        fullWidth={true}
                        name={'clinics'}
                        disabled={clinics.length === 1}
                        variant="outlined"
                        value={
                          clinics.length === 1
                            ? [clinics[0].name]
                            : selectedClinic
                            ? [clinicLabels]
                            : [t('PATIENTS.SELECT_CLINICS')]
                        }
                        style={
                          clinics.length === 1
                            ? {}
                            : selectedClinic
                            ? {}
                            : {opacity: '0.5', cursor: 'pointer'}
                        }
                        renderValue={selected =>
                          (selected as string[]).join(', ')
                        }
                        IconComponent={KeyboardArrowDownIcon}>
                        <div className={ClinicClasses.root}>
                          <div className={ClinicClasses.ClinicFilterHeader}>
                            <Typography
                              style={{
                                fontSize: '1.5rem',
                                fontStyle: 'regular'
                              }}>
                              {t('PATIENTS.CLINICS')}
                            </Typography>
                            <Button
                              className={ClinicClasses.clearall}
                              onClick={clearClinicFilter}>
                              {t('COMMON.CLEAR_ALL')}
                            </Button>
                          </div>
                          <Divider />
                          <div className={ClinicClasses.ClinicMenu}>
                            {clinics.map((clinic: any, index: any) => (
                              <MenuItem
                                key={clinic.id}
                                value={clinic.name}
                                onClick={(e: any): void =>
                                  handleClinicSelect(e, clinic)
                                }>
                                <ListItemText
                                  className={[
                                    ClinicClasses.secondary,
                                    ClinicClasses.primary
                                  ].join(' ')}
                                  primary={clinic.name}
                                  secondary={`${clinic.city}, ${clinic.country}`}
                                />
                                <Radio checked={selectedClinic == clinic.id} />
                              </MenuItem>
                            ))}
                          </div>
                        </div>
                      </Select>
                    )}
                    error={!!errors.clinic}
                  />
                  {errors.clinic && (
                    <FormHelperText>{t(errors.clinic)}</FormHelperText>
                  )}
                </FormControl>
              </div>
            ) : (
              ''
            )}

            <div className="add-clinic-left-wrap">
              <div className="addressText">
                {t('ADD_PATIENT.PATIENT_INFO_TITLE')}
                {!fromEdit && (
                  <Button
                    onClick={handleAddPatient}
                    variant={'contained'}
                    color="primary"
                    disabled={buttonsDisable}>
                    {t('ADD_PATIENT.ADD')}
                  </Button>
                )}
              </div>
              <div className="dividerView" />
              {patientsComponents.map((_, idx) => {
                return (
                  <>
                    {idx >= patientDetails.length && (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end'
                        }}>
                        <Tooltip
                          title={`${t('ADD_PATIENT.DELETE')}`}
                          placement="top">
                          <IconButton
                            data-test-id={`pcl-patients-deletePatient${idx}`}
                            className={'custom-icon-button'}
                            onClick={(): void => {
                              setDialogContent({
                                dialogTitle: t('CONFIRMATION_DIALOG.CONFIRM'),
                                dialogDescription: t(
                                  'CONFIRMATION_DIALOG.CONFIRM_SUB_TITLE'
                                ),
                                cancelButtonText: t(
                                  'CONFIRMATION_DIALOG.CANCEL'
                                ),
                                confirmButtonText: t(
                                  'CONFIRMATION_DIALOG.YES_DELETE'
                                ),
                                buttonStyle: {
                                  backgroundColor: DEFAULT_RED_COLOR
                                }
                              });
                              setDeleteIndex(idx);
                              handlePopUpDialog(idx);
                            }}>
                            <DeleteForeverIcon />
                          </IconButton>
                        </Tooltip>
                      </div>
                    )}
                    {idx !== 0 && <div className="dividerView" />}
                    {renderPatientForm(idx)}
                    <div style={{display: 'none'}}>{patientIdForm(idx)}</div>
                  </>
                );
              })}

              {/* GUARANTOR  DETAILS SECTION */}
              <div className="addressText">
                {t('ADD_PATIENT.GUARANTOR_INFO_TITLE')}
              </div>
              <div className="dividerView" />
              <Grid container spacing={1}>
                <Grid item xs={6} sm={4}>
                  <div>{t('ADD_PATIENT.GUARANTOR.FIRST_NAME')}*</div>
                  <FormControl
                    error={!!errors.first_name}
                    fullWidth={true}
                    variant="outlined"
                    onChange={() => {
                      updateUnsavedFlag();
                    }}>
                    <Controller
                      id="first_name"
                      as={StyledOutlinedInput}
                      margin={'dense'}
                      control={control}
                      name={'first_name'}
                      type={'text'}
                      value={'text'}
                      autoComplete="on"
                      placeholder={t(
                        'ADD_PATIENT.PLACEHOLDERS.GUARANTOR_FIRST_NAME'
                      )}
                      error={!!errors.first_name}
                      disabled={
                        (toggleCheck === guarantorCheck && toggleCheck >= 0) ||
                        addPatientToGuarantor
                      }
                      defaultValue={
                        fromEdit
                          ? editPatientContext?.guarantor_first_name ?? ''
                          : ''
                      }
                    />
                    {errors.first_name && (
                      <FormHelperText>{t(errors.first_name)}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={6} sm={4}>
                  <div>{t('ADD_PATIENT.GUARANTOR.MIDDLE_NAME')}</div>
                  <FormControl
                    error={!!errors.middle_name}
                    fullWidth={true}
                    variant="outlined"
                    onChange={() => {
                      updateUnsavedFlag();
                    }}>
                    <Controller
                      id="middle_name"
                      as={StyledOutlinedInput}
                      margin={'dense'}
                      control={control}
                      name={'middle_name'}
                      type={'text'}
                      value={'text'}
                      autoComplete="on"
                      placeholder={t(
                        'ADD_PATIENT.PLACEHOLDERS.GUARANTOR_MIDDLE_NAME'
                      )}
                      error={!!errors.middle_name}
                      disabled={
                        (toggleCheck === guarantorCheck && toggleCheck >= 0) ||
                        addPatientToGuarantor
                      }
                      defaultValue={
                        fromEdit
                          ? editPatientContext?.guarantor_middle_name ?? ''
                          : ''
                      }
                    />
                    {errors.middle_name && (
                      <FormHelperText>{t(errors.middle_name)}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={6} sm={4}>
                  <div>{t('ADD_PATIENT.GUARANTOR.LAST_NAME')}*</div>
                  <FormControl
                    error={!!errors.last_name}
                    fullWidth={true}
                    variant="outlined"
                    onChange={() => {
                      updateUnsavedFlag();
                    }}>
                    <Controller
                      id="last_name"
                      as={StyledOutlinedInput}
                      margin={'dense'}
                      control={control}
                      name={'last_name'}
                      type={'text'}
                      value={'text'}
                      autoComplete="on"
                      placeholder={t(
                        'ADD_PATIENT.PLACEHOLDERS.GUARANTOR_LAST_NAME'
                      )}
                      error={!!errors.last_name}
                      disabled={
                        (toggleCheck === guarantorCheck && toggleCheck >= 0) ||
                        addPatientToGuarantor
                      }
                      defaultValue={
                        fromEdit
                          ? editPatientContext?.guarantor_last_name ?? ''
                          : ''
                      }
                    />
                    {errors.last_name && (
                      <FormHelperText>{t(errors.last_name)}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={6} sm={4}>
                  <div>{t('ADD_PATIENT.GUARANTOR.ACCOUNT_NUMBER')}</div>
                  <FormControl
                    error={!!errors.account_number}
                    fullWidth={true}
                    variant="outlined"
                    onChange={() => {
                      updateUnsavedFlag();
                    }}>
                    <Controller
                      id="account_number"
                      as={StyledOutlinedInput}
                      margin={'dense'}
                      control={control}
                      name={'account_number'}
                      type={'text'}
                      value={'text'}
                      autoComplete="on"
                      placeholder={t(
                        'ADD_PATIENT.PLACEHOLDERS.GUARANTOR_ACCOUNT_NUMBER'
                      )}
                      error={!!errors.account_number}
                      disabled={
                        (toggleCheck === guarantorCheck && toggleCheck >= 0) ||
                        addPatientToGuarantor
                      }
                      defaultValue={
                        fromEdit
                          ? editPatientContext?.guarantor_emr_id ?? ''
                          : ''
                      }
                    />
                    {errors.account_number && (
                      <FormHelperText>
                        {t(errors.account_number)}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={6} sm={4}>
                  <div>{t('ADD_PATIENT.GUARANTOR.PHONE_1')}*</div>
                  <FormControl
                    error={!!errors.phone_1}
                    fullWidth={true}
                    variant="outlined"
                    onChange={() => {
                      updateUnsavedFlag();
                    }}>
                    <Controller
                      id="phone_1"
                      as={
                        <PhoneInputField
                          value={''}
                          inputProps={{
                            name: 'phone_1',
                            id: 'phone_1',
                            required: false
                          }}
                          onChange={(value: any, country: CountryData) =>
                            handleOnChange(value, country, 'phone_1')
                          }
                        />
                      }
                      margin={'dense'}
                      control={control}
                      name={'phone_1'}
                      type={'number'}
                      value={'text'}
                      autoComplete="on"
                      placeholder={t(
                        'ADD_PATIENT.PLACEHOLDERS.GUARANTOR_PHONE'
                      )}
                      error={!!errors.phone_1}
                      defaultValue={
                        fromEdit
                          ? editPatientContext?.guarantor_notification_phone ??
                            ''
                          : getValues('phone_1')
                      }
                    />
                    {errors.phone_1 && (
                      <FormHelperText>{t(errors.phone_1)}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={6} sm={4}>
                  <div>{t('ADD_PATIENT.GUARANTOR.PHONE_2')}</div>
                  <FormControl
                    fullWidth={true}
                    variant="outlined"
                    onChange={() => {
                      updateUnsavedFlag();
                    }}>
                    <Controller
                      id="phone_2"
                      as={
                        <PhoneInputField
                          value={''}
                          inputProps={{
                            name: 'phone_2',
                            id: 'phone_2',
                            required: false
                          }}
                          onChange={(value: any, country: CountryData) =>
                            handleOnChange(value, country, 'phone_2')
                          }
                        />
                      }
                      margin={'dense'}
                      control={control}
                      name={'phone_2'}
                      type={'number'}
                      value={'text'}
                      autoComplete="on"
                      placeholder={t(
                        'ADD_PATIENT.PLACEHOLDERS.GUARANTOR_PHONE_2'
                      )}
                      error={!!errors.phone_2}
                      defaultValue={
                        fromEdit
                          ? editPatientContext?.guarantor_phone_2 ?? ''
                          : getValues('phone_2')
                      }
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={6} sm={4}>
                  <div>{t('ADD_PATIENT.GUARANTOR.PHONE_3')}</div>
                  <FormControl
                    fullWidth={true}
                    variant="outlined"
                    onChange={() => {
                      updateUnsavedFlag();
                    }}>
                    <Controller
                      id="phone_3"
                      as={
                        <PhoneInputField
                          value={''}
                          inputProps={{
                            name: 'phone_3',
                            id: 'phone_3',
                            required: false
                          }}
                          onChange={(value: any, country: CountryData) =>
                            handleOnChange(value, country, 'phone_3')
                          }
                        />
                      }
                      margin={'dense'}
                      control={control}
                      name={'phone_3'}
                      type={'number'}
                      value={'text'}
                      autoComplete="on"
                      placeholder={t(
                        'ADD_PATIENT.PLACEHOLDERS.GUARANTOR_PHONE_3'
                      )}
                      error={!!errors.phone_3}
                      defaultValue={
                        fromEdit
                          ? editPatientContext?.phone_3 ?? ''
                          : getValues('phone_3')
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={6} sm={4}>
                  <div>{t('ADD_PATIENT.GUARANTOR.EMAIL')}</div>
                  <FormControl
                    error={!!errors.email}
                    fullWidth={true}
                    variant="outlined"
                    onChange={() => {
                      updateUnsavedFlag();
                    }}>
                    <Controller
                      id="email"
                      as={StyledOutlinedInput}
                      margin={'dense'}
                      control={control}
                      name={'email'}
                      type={'text'}
                      value={'email'}
                      autoComplete="on"
                      placeholder={t(
                        'ADD_PATIENT.PLACEHOLDERS.GUARANTOR_EMAIL'
                      )}
                      error={!!errors.email}
                      disabled={
                        (toggleCheck === guarantorCheck && toggleCheck >= 0) ||
                        addPatientToGuarantor
                      }
                      defaultValue={
                        fromEdit
                          ? editPatientContext?.guarantor_email ?? ''
                          : ''
                      }
                    />
                    {errors.email && (
                      <FormHelperText>{t(errors.email)}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <div>{t('ADD_PATIENT.ADDRESS_LINE_1')}</div>
                  <FormControl
                    error={!!errors.address_line_1}
                    fullWidth={true}
                    variant="outlined"
                    onChange={() => {
                      updateUnsavedFlag();
                    }}>
                    <Controller
                      id="address_line_1"
                      as={StyledOutlinedInput}
                      margin={'dense'}
                      control={control}
                      name={'address_line_1'}
                      type={'text'}
                      value={'text'}
                      autoComplete="on"
                      placeholder={t('FORM.PLACEHOLDERS.ADDRESS_1')}
                      error={!!errors.address_line_1}
                      disabled={
                        (toggleCheck === guarantorCheck && toggleCheck >= 0) ||
                        addPatientToGuarantor
                      }
                      defaultValue={
                        fromEdit
                          ? editPatientContext?.guarantor_address_line_1 ?? ''
                          : ''
                      }
                    />
                    {errors.address_line_1 && (
                      <FormHelperText>
                        {t(errors.address_line_1)}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={6} sm={4}>
                  <div>{t('ADD_PATIENT.ADDRESS_LINE_2')}</div>
                  <FormControl
                    fullWidth={true}
                    variant="outlined"
                    onChange={() => {
                      updateUnsavedFlag();
                    }}>
                    <Controller
                      id="address_line_2"
                      as={StyledOutlinedInput}
                      margin={'dense'}
                      control={control}
                      name={'address_line_2'}
                      type={'text'}
                      value={'text'}
                      autoComplete="on"
                      placeholder={t('FORM.PLACEHOLDERS.ADDRESS_2')}
                      disabled={
                        (toggleCheck === guarantorCheck && toggleCheck >= 0) ||
                        addPatientToGuarantor
                      }
                      defaultValue={
                        fromEdit
                          ? editPatientContext?.guarantor_address_line_2 ?? ''
                          : ''
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={6} sm={4}>
                  <div>{t('ADD_PATIENT.CITY')}</div>
                  <FormControl
                    error={!!errors.city}
                    fullWidth={true}
                    variant="outlined"
                    onChange={() => {
                      updateUnsavedFlag();
                    }}>
                    <Controller
                      id="city"
                      as={StyledOutlinedInput}
                      margin={'dense'}
                      control={control}
                      name={'city'}
                      type={'text'}
                      value={'text'}
                      autoComplete="on"
                      placeholder={t('FORM.PLACEHOLDERS.CITY')}
                      error={!!errors.city}
                      disabled={
                        (toggleCheck === guarantorCheck && toggleCheck >= 0) ||
                        addPatientToGuarantor
                      }
                      defaultValue={
                        fromEdit ? editPatientContext?.guarantor_city ?? '' : ''
                      }
                    />
                    {errors.city && (
                      <FormHelperText>{t(errors.city)}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <div style={{marginBottom: '8px'}}>
                    {t('ADD_PATIENT.STATE')}
                  </div>
                  <FormControl
                    error={!!errors.state}
                    fullWidth={true}
                    variant="outlined">
                    <Controller
                      id="state"
                      margin={'dense'}
                      render={({
                        onChange,
                        onBlur,
                        value
                      }): React.ReactElement => (
                        <Select
                          id="designation-selector"
                          value={value}
                          data-test-id="pcl-practices-guarantorState"
                          onChange={(data: any) => {
                            updateUnsavedFlag();
                            onChange(data);
                          }}
                          onBlur={onBlur}
                          fullWidth={true}
                          variant="outlined"
                          margin="dense"
                          disabled={
                            (toggleCheck === guarantorCheck &&
                              toggleCheck >= 0) ||
                            addPatientToGuarantor
                          }
                          IconComponent={KeyboardArrowDownIcon}
                          input={<CustomSelectField />}
                          className={[classes.input].join(' ')}
                          placeholder={t('FORM.PLACEHOLDERS.STATE')}
                          style={
                            errors.state
                              ? {...StateErrorStyles}
                              : value === t('FORM.PLACEHOLDERS.STATE') ||
                                (toggleCheck === guarantorCheck &&
                                  toggleCheck >= 0) ||
                                addPatientToGuarantor
                              ? {...stateObjectOpacity}
                              : {...stateObjectStyles}
                          }>
                          {statesList.map(
                            (
                              item: {
                                name: string | number | string[] | undefined;
                                label: React.ReactNode;
                              },
                              stateIdx: number
                            ) => (
                              <MenuItem
                                value={item.name}
                                key={`guarantor-state-${String(
                                  item.name
                                )}-${stateIdx}`}>
                                {item.name}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      )}
                      control={control}
                      name={'state'}
                      error={!!errors.state}
                      defaultValue={
                        fromEdit
                          ? editPatientContext?.guarantor_state ?? ''
                          : ''
                      }
                    />
                    {errors.state && (
                      <FormHelperText>{t(errors.state)}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <div>{t('ADD_PATIENT.ZIP_CODE')}</div>
                  <FormControl
                    error={!!errors.zip_code}
                    fullWidth={true}
                    variant="outlined"
                    onChange={() => {
                      updateUnsavedFlag();
                    }}>
                    <Controller
                      id="zip_code"
                      as={StyledOutlinedInput}
                      margin={'dense'}
                      control={control}
                      name={'zip_code'}
                      type={'number'}
                      value={'text'}
                      autoComplete="on"
                      placeholder={t('FORM.PLACEHOLDERS.ZIP')}
                      onInput={(e: any) => {
                        e.target.value = validateZipCode(e);
                      }}
                      error={!!errors.zip_code}
                      disabled={
                        (toggleCheck === guarantorCheck && toggleCheck >= 0) ||
                        addPatientToGuarantor
                      }
                      defaultValue={
                        fromEdit
                          ? editPatientContext?.guarantor_zip_code ?? ''
                          : ''
                      }
                    />
                    {errors.zip_code && (
                      <FormHelperText className={classes.zipText}>
                        {t(errors.zip_code)}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => checkIsFormDirty()} disabled={buttonsDisable}>
            {t('ADD_PATIENT.CANCEL')}
          </Button>
          <Button
            variant={'contained'}
            onClick={handleSubmit(handleFormSubmit, checkFormState)}
            color="primary"
            disabled={buttonsDisable}
            type={'submit'}>
            {buttonsDisable ? (
              <ButtonLoader />
            ) : fromEdit ? (
              t('ADD_PATIENT.UPDATE_PATIENT')
            ) : (
              t('ADD_PATIENT.SAVE')
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {openDialog && showConfirmationStatementDialog(deleteIndex)}

      {showAddInsuranceAndBookAppointmentDialog && (
        <Dialog
          open={showAddInsuranceAndBookAppointmentDialog}
          aria-labelledby="patient-added-dialog"
          fullWidth
          maxWidth="sm"
          disableEscapeKeyDown>
          <DialogTitle id="patient-added-dialog">
            <div className="add-patient-success-title">
              {' '}
              {t('ADD_PATIENT.PATIENT_ADD_SUCCESS')}
            </div>
          </DialogTitle>

          <DialogContent dividers>
            <div className="add-patient-success-description">
              {t('ADD_PATIENT.PATIENT_ADD_SUCCESS_DESCRIPTION')}
            </div>

            <div className="add-patient-success-next-button">
              {t('ADD_PATIENT.PATIENT_ADD_SUCCESS_NEXT_BUTTON')}
            </div>

            <div className="add-patient-success-next-button-container">
              {/* Add Insurance */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setShowAddInsuranceAndBookAppointmentDialog(false);
                  setShowVerifyInsuranceModal(true);
                }}>
                {t('ADD_PATIENT.PATIENT_ADD_SUCCESS_NEXT_BUTTON_ADD_INSURANCE')}
              </Button>

              {/* Book Appointment */}
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  setShowAddInsuranceAndBookAppointmentDialog(false);
                  if (!scheduleAppointmentClinicId) {
                    enqueueSnackbar(
                      t(
                        'ADD_PATIENT.SELECT_PRACTICE_TO_SCHEDULE_APPOINTMENT'
                      ),
                      SnackBarConfig('w')
                    );
                    handleClose('confirm');
                    return;
                  }
                  setShowScheduleAppointmentDialog(true);
                }}>
                {t(
                  'ADD_PATIENT.PATIENT_ADD_SUCCESS_NEXT_BUTTON_BOOK_APPOINTMENT'
                )}
              </Button>
            </div>
            <Typography
              variant="body2"
              color="textSecondary"
              component="p"
              style={{marginTop: '1.25rem'}}>
              {t('ADD_PATIENT.PATIENT_ADD_SUCCESS_CLOSE_CAPTION')}
            </Typography>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={() => {
                setShowAddInsuranceAndBookAppointmentDialog(false);
                handleClose('confirm');
              }}
              color="primary"
              variant="text">
              {t('ADD_PATIENT.PATIENT_ADD_SUCCESS_DONE')}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {showVerifyInsuranceModal && verifyInsuranceContext && (
        <VerifyInsuranceModal
          key={`add-edit-insurance-new-${verifyInsuranceContext.patientId}`}
          isOpen={showVerifyInsuranceModal}
          handleClose={() => {
            setShowVerifyInsuranceModal(false);
            handleClose('confirm');
          }}
          clinicGroupId={clinicGroupId}
          clinicId={verifyInsuranceContext.clinicId}
          patientId={verifyInsuranceContext.patientId}
          onCancel={() => {
            setShowVerifyInsuranceModal(false);
            handleClose('confirm');
          }}
          defaultInsuranceValues={null}
          mode="add"
          onSuccess={() => {
            setShowVerifyInsuranceModal(false);
            handleClose('confirm');
          }}
        />
      )}

      {showScheduleAppointmentDialog && scheduleAppointmentClinicId && (
        <div className={classes.scheduleAppointment}>
          <ScheduleAppointment
            close={() => {
              setShowScheduleAppointmentDialog(false);
              setScheduleAppointmentClinicId(null);
              setScheduleAppointmentPatient(null);
              handleClose('confirm');
            }}
            clinicId={scheduleAppointmentClinicId}
            clinicGroupId={Number(clinicGroupId)}
            preselectedPatient={scheduleAppointmentPatient ?? undefined}
            onAppointmentBooked={() => {
              setShowScheduleAppointmentDialog(false);
              setScheduleAppointmentClinicId(null);
              setScheduleAppointmentPatient(null);
              handleClose('confirm');
              CommunicationService.sendEvent({
                action: 'NAVIGATE_TO_APPOINTMENT_TAB',
                data: undefined
              });
              history.push(
                `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.APPOINTMENTS}`
              );
            }}
          />
        </div>
      )}
    </div>
  );
};

function mapStateToProps(state: any): any {
  return {
    emr: state.clinics.emrProvider
  };
}
export default connect(mapStateToProps, {})(AddPatient);
